// Chakra imports
import { Avatar, Box, Flex, Text, useColorModeValue } from "@chakra-ui/react";
import Card from "components/card/Card.js";
import React from "react";
import { currentUser } from "utils/CurrentUser";

export default function Banner(props) {
  const { banner, avatar, name, job, posts, followers, following,fullName } = props;
  // Chakra Color Mode
  const textColorPrimary = useColorModeValue("secondaryGray.900", "white");
  const textColorSecondary = "gray.400";
  const borderColor = useColorModeValue(
    "white !important",
    "#111C44 !important"
  );
  return (
    <Card mb={{ base: "0px", lg: "20px" }} align='center'>
      <Box
        bg={`url(${banner})`}
        bgSize='cover'
        borderRadius='16px'
        h='131px'
        w='100%'
      />
      <Avatar
        mx='auto'
        name={fullName}
        h='87px'
        w='87px'
        mt='-43px'
        border='4px solid'
        bg="#11047A"
        color="white"
        borderColor={borderColor}
      />
      <Text color={textColorPrimary} fontWeight='bold' fontSize='xl' mt='10px'>
        {fullName}
      </Text>
      {/* <Flex w='max-content' mx='auto' mt='26px'>
        <Flex mx='auto' me='60px' align='center' direction='column'>
          <Text color={textColorPrimary} fontSize='2xl' fontWeight='700'>
            {currentUser?.ongoingSkillsCount}
          </Text>
          <Text color={textColorSecondary} fontSize='sm' fontWeight='400'>
            Ongoing
          </Text>
        </Flex>
        <Flex mx='auto' me='60px' align='center' direction='column'>
          <Text color={textColorPrimary} fontSize='2xl' fontWeight='700'>
            {currentUser?.completedSkillsCount}
          </Text>
          <Text color={textColorSecondary} fontSize='sm' fontWeight='400'>
            Completed
          </Text>
        </Flex>
        <Flex mx='auto' align='center' direction='column'>
          <Text color={textColorPrimary} fontSize='2xl' fontWeight='700'>
            {currentUser?.totalPoints}
          </Text>
          <Text color={textColorSecondary} fontSize='sm' fontWeight='400'>
            Total pts.
          </Text>
        </Flex> */}
      {/* </Flex> */}
    </Card>
  );
}
